var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 490",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line_15_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.428,
    y: 169.984,
    width: 137.813,
    height: 30.625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.428,
    y: 246.547,
    width: 137.813,
    height: 30.625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.428,
    y: 323.109,
    width: 137.813,
    height: 30.625
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.836,150.537 324.319,191.054 299.099,165.85 288.273,176.676 324.319,212.706 375.662,161.363  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.836,223.272 324.319,263.788 299.099,238.584 288.273,249.41 324.319,285.44 375.662,234.098  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.099,311.303 288.273,322.129 324.319,358.175 375.662,306.817 364.836,295.991 324.319,336.523  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.963,28.282 357.287,28.282 357.287,58.907 408.338,58.907 408.338,459.375 81.662,459.375 81.662,58.907  127.599,58.907 127.599,28.282 51.037,28.282 51.037,490 438.963,490  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.117,
    width: 147.781,
    height: 59.397
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.25d36c02.svg";
export { ForwardRef as ReactComponent };